import { mascararCnpj } from './cnpj'

/** Máscara progressiva de CNPJ, numérico ou alfanumérico (letras viram maiúsculas). */
export const maskCNPJ = (value: string): string => mascararCnpj(value)

export const maskCPF = (value: string): string => {
  const clean = value.replace(/\D/g, '').slice(0, 11)
  return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export const maskCEP = (value: string): string => {
  const clean = value.replace(/\D/g, '').slice(0, 8)
  return clean.replace(/(\d{5})(\d{3})/, '$1-$2')
}

export const maskPhone = (value: string): string => {
  const clean = value.replace(/\D/g, '').slice(0, 11)
  if (clean.length <= 10) {
    return clean.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  }
  return clean.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
}

export const maskCurrency = (value: string): string => {
  const clean = value.replace(/\D/g, '')
  if (!clean) return '0,00'
  const amount = (parseInt(clean) / 100).toFixed(2)
  return amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const maskPercentage = (value: string): string => {
  const clean = value.replace(/\D/g, '').slice(0, 5)
  if (!clean) return '0,00'
  const num = parseInt(clean) / 100
  return num.toFixed(2).replace('.', ',')
}

export const unmaskValue = (value: string): string => {
  return value.replace(/\D/g, '')
}
